import React from "react";
import { UseFormRegister, FieldValues, Path } from "react-hook-form";
import { FiChevronDown } from "react-icons/fi";

export type SelectOption = {
  label: string;
  value: string;
};

const SelectWithForm = <T extends FieldValues>({
  name,
  register,
  options,
  required,
  requiredMessage,
  label,
  initialValue = "担当者から絞り込み",
}: {
  name: Path<T>;
  register: UseFormRegister<T>;
  options: SelectOption[];
  required: boolean;
  requiredMessage?: string;
  label?: string;
  initialValue?: string;
}) => {
  const requiredOptions = required ? { required: requiredMessage || "選択してください。" } : {};

  return (
    <div className="relative flex items-center gap-2">
      <p className="text-14px">{label}</p>
      <div className="relative text-14px">
        <div className="flex h-12 w-[200px] items-center justify-between rounded border border-input-normal bg-input-normal px-4 text-black">
          <select
            {...register(name, requiredOptions)}
            className="h-full w-full appearance-none bg-transparent outline-none"
          >
            <option value="">{initialValue}</option>
            {options.map((option, index) => (
              <option key={index} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
          <FiChevronDown size={24} color="#706D65" />
        </div>
      </div>
    </div>
  );
};

export default SelectWithForm;
